<script setup>
/*
 * Prisudviklingen i en kategori.
 *
 * VI SIGER HVAD VI BYGGER PAA. Historikken har huller — 20. november til
 * 4. december 2025 mangler helt — saa antallet af faktisk maalte dage
 * staar under tallene.
 */
import { computed } from 'vue';

const props = defineProps({ data: { type: Object, required: true } });

const punkter = computed(() => props.data.punkter || []);

const faldet = computed(() => punkter.value.reduce((s, p) => s + p.faldet, 0));
const steget = computed(() => punkter.value.reduce((s, p) => s + p.steget, 0));
const sidste = computed(() => punkter.value[punkter.value.length - 1] || null);
const hul = computed(() => props.data.dage && props.data.maalteDage < props.data.dage * 0.8);
</script>

<template>
    <p v-if="!data.kategori" class="text-secondary small mb-0">Ingen kategori valgt.</p>
    <p v-else-if="!punkter.length" class="text-secondary small mb-0">
        Vi har ingen målinger for {{ data.kategori.navn }} i perioden.
    </p>

    <div v-else>
        <div class="row g-3 mb-2">
            <div class="col-sm-4">
                <div class="tal">
                    <span class="tal__vaerdi text-success">{{ faldet }}</span>
                    <span class="tal__etiket">prisfald</span>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="tal">
                    <span class="tal__vaerdi text-danger">{{ steget }}</span>
                    <span class="tal__etiket">prisstigninger</span>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="tal">
                    <span class="tal__vaerdi">{{ sidste?.varer ?? 0 }}</span>
                    <span class="tal__etiket">varer vi følger</span>
                </div>
            </div>
        </div>

        <p class="small text-secondary mb-0">
            {{ data.kategori.navn }}, de seneste {{ data.dage }} dage.
            Tallene bygger på {{ data.maalteDage }} dage med målinger<span v-if="hul">
            — færre end perioden, fordi vi ikke har målt hver dag</span>.
        </p>
    </div>
</template>

<style scoped>
.tal { border: 1px solid var(--pc-border); border-radius: var(--pc-radius); padding: .75rem 1rem; text-align: center; }
.tal__vaerdi { display: block; font-size: 1.8rem; font-weight: 700; line-height: 1.1; }
.tal__etiket { color: var(--pc-text-secondary); font-size: .85rem; }
</style>
